import Cookies from 'js-cookie';
import actions from './actions';
import { GuestService } from '../../config/data/guestService';

const {
    loginBegin,
    loginSuccess,
    loginErr,
    logoutBegin,
    logoutSuccess,
    logoutErr,
} = actions;

const getErrorMessage = (err, fallback = 'Login failed') => {
    if (typeof err === 'string') {
        return err;
    }

    return err?.response?.data?.message || err?.data?.message || err?.message || fallback;
};

const login = (data) => {
    return async (dispatch) => {
        try {
            dispatch(loginBegin());
            const response = await GuestService.post('/login', data);

            if (response.status === 200 && response.data.status === true) {
                Cookies.set('SangLoggedIn', true);
                Cookies.set('SangLoggedData', JSON.stringify(response.data));
                dispatch(loginSuccess(true, response.data));
            } else {
                dispatch(loginErr(response.data?.message || 'Invalid username or password'));
            }
        } catch (err) {
            dispatch(loginErr(getErrorMessage(err)));
        }
    };
};

const logOut = () => {
    return async (dispatch) => {
        try {
            dispatch(logoutBegin());
            await GuestService.delete('/logout');
            Cookies.remove('SangLoggedIn');
            Cookies.remove('SangLoggedData');
            dispatch(logoutSuccess(true));
        } catch (err) {
            Cookies.remove('SangLoggedIn');
            Cookies.remove('SangLoggedData');
            dispatch(logoutErr(getErrorMessage(err, 'Logout failed')));
        }
    };
};

export { login, logOut };
